/**
 * Description facts container — layout for channel + facts line on description.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const DescriptionFactsContainer = styled.div`
  align-self: stretch;
  box-sizing: border-box;
  margin-bottom: ${12 * Screen.widthRatio}px;
  max-width: ${1020 * Screen.widthRatio}px;
  overflow: hidden;
  width: 100%;
`;

export default DescriptionFactsContainer;
